import CardTable from "components/CardTable/CardTable";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import WidgetsIcon from "@material-ui/icons/Widgets";
import { useDispatch, useSelector } from "react-redux";
import { saveInventory } from "redux/actions/inventories/inventoriesAction";
import { validateObject } from "helpers/validateObject";
import { SaveInventoryButton } from "./SaveInventoryButton";
import { inventoryType } from "./inventoryType.enum";
import { columnsStation_actual } from "./columnsStation";
import { useColumnsStationDigital } from "./useColumnsStationDigital";

export const StationaryTable = ({
  title = "",
  keyInventory = "",
  endpoint = "",
  edited = ""
}) => {
  const dispatch = useDispatch();
  const { inventory, station } = useSelector(({ inventories }) => inventories);
  const { stationaryInventory } = inventory?.details;
  const { isLoadingComp } = useSelector(({ search }) => search);

  const hist = useHistory();
  const handleGo = () => {
    hist.push("/admin/control-inventarios");
  };

  const handleSave = (e) => {
    e.preventDefault();
    const mapData = stationaryInventory.map(inv => ({
      ...inv,
      currentPercentage: inv.currentPercentage === "" ? 0 : inv.currentPercentage
    }));
    dispatch(saveInventory(inventory.id, endpoint, mapData, keyInventory));
  };

  useEffect(() => {
    validateObject(inventory, true) && handleGo();
  }, [inventory]); 

  const columnsDigital = useColumnsStationDigital(endpoint, keyInventory, edited);

  const columnsToUse = station?.inventory_type === inventoryType.digital || station?.inventory_type === inventoryType.progressive
    ? columnsDigital
    : columnsStation_actual;

  return (
    <CardTable
      hasHeader
      title={title}
      icon={<WidgetsIcon />}
      blockBtn
      columns={columnsToUse}
      data={inventory?.details?.stationaryInventory}
      hasControl={Boolean(inventory[edited])}
      isLoading={isLoadingComp?.loadingInventoryType}
      controls={<SaveInventoryButton handleSave={handleSave} />}
    />
  );
};
